'use strict';
const Ajax = require('common/infra/ajax');

class API {
    constructor(path) {
        this._path = path;
    }
    getUploadUrl() {
        return Ajax.POST(this._path);
    }
    path() {
        return this._path;
    }
}

class Factory {
    buildUser() {
        return new API('/api/my/blobs')
    }
    buildGroup(groupId) {
        return new API(`/api/groups/${groupId}/blobs`)
    }
}

module.exports = new Factory();



// WEBPACK FOOTER //
// ./common/infra/api/blob-factory.js